// this file contains version which is a string that is intended to be populated with version data from a combination of git tags and commit hash
// see README.md for local environemnt setup

import { Component, OnInit, inject } from '@angular/core';
import { CAPICHE_VERSION_CONFIG } from './capiche-version.config';

@Component({
  selector: 'app-version-string',
  imports: [],
  templateUrl: './version-string.component.html',
  styleUrls: ['./version-string.component.css'],
})
export class VersionStringComponent implements OnInit {
  public version = inject(CAPICHE_VERSION_CONFIG).version;
  constructor() {}

  ngOnInit(): void {}
}
